import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Test-Modus (siehe index.html): Backend markiert diese Requests als Testlauf.
api.interceptors.request.use((config) => {
  if (typeof window !== "undefined" && window.__f4s_testMode) {
    config.headers = config.headers || {};
    config.headers["X-F4S-Test-Run"] = "1";
  }
  return config;
});

// Eingeloggtes Testkonto: Browser dauerhaft in Test-Modus versetzen.
export function markTestAccountBrowser() {
  if (typeof window === "undefined" || window.__f4s_testMode) return;
  window.__f4s_testMode = true;
  try { window.localStorage.setItem("f4s_test_mode", "1"); } catch (_e) { /* noop */ }
  try { if (typeof window.gtag === "function") window.gtag("set", { traffic_type: "internal" }); } catch (_e) { /* noop */ }
  window.fbq = function () {};
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
